import React from 'react'

type Props = {}

const Check = (props: Props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="11" height="9">
			<path fill="none" stroke="#FFF" strokeWidth="2" d="M1 4.304L3.696 7l6-6" />
		</svg>
	)
}

export default Check
